import { Controller } from "@hotwired/stimulus"

// The image-fallback controller is used to provide a fallback image for images that fail to load.
export default class extends Controller {
  static get values() {
    return { fallbackUrl: String }
  }

  connect() {
    this.element.onerror = () => {
      this.element.onerror = null
      this.element.src = this.fallbackUrlValue
    }

    if (!this.src) {
      this.element.remove()
    }
  }
}
